import React, { useContext } from 'react'
import { Flex } from 'pcln-design-system'
import { HighlightedFlex } from '@pcln/brand'
import Pricebreakers from '@/components/Promos/Pricebreakers/Pricebreakers'
import VIPPromo from '@/components/Promos/VIP/VIPPromo'
import BootstrapDataContext from '@/context/BootstrapDataContext'
import IncredibleTile from '@/components/Promos/IncredibleTile/IncredibleTile'
import ConditionalRender from './ConditionalRender'

export default function PromoFeatureBox() {
  const {
    isMobile = false,
    signInStatus: { signedIn = false }
  } = useContext(BootstrapDataContext)

  const heroSpacing = isMobile
    ? {
        my: [1, null, 4]
      }
    : {
        mt: [1, null, null, -4, 0],
        mb: [1, null, 4],
        style: { position: 'relative' }
      }

  return (
    <Flex mx="auto" justifyContent="center" {...heroSpacing}>
      <ConditionalRender
        experimentCode="HP_PROMOS_BLUE_TINT"
        variantValue="VARIANT"
        experiment={
          <HighlightedFlex
            shadowOffsetX={24}
            shadowOffsetY={24}
            maxWidth={1216}
            flexWrap={['wrap', null, 'unset']}
          >
            {signedIn ? (
              <VIPPromo isMobile={isMobile} />
            ) : (
              <Pricebreakers isMobile={isMobile} />
            )}
            <IncredibleTile />
          </HighlightedFlex>
        }
        original={
          <Flex
            maxWidth={1280}
            px={[0, '20px']}
            flexWrap={['wrap', null, 'unset']}
          >
            {signedIn ? (
              <VIPPromo isMobile={isMobile} />
            ) : (
              <Pricebreakers isMobile={isMobile} />
            )}
            <IncredibleTile />
          </Flex>
        }
      />
    </Flex>
  )
}
